// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ShopCategoriesListResourceViewModel from '../../../../viewModel/resource/ShopCategoriesListResourceViewModel';
import ShopCategoriesListResourceDTO from '../../dto/resource/ShopCategoriesListResourceDTO';

export default abstract class ShopCategoriesListResourceModel extends BaseModel<ShopCategoriesListResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get parentCategoryId() { return this.dto.parentCategoryId; }
  set parentCategoryId(value) { this.dto.parentCategoryId = value; }
  /**
  */
  get language_ISO2() { return this.dto.language_ISO2; }
  set language_ISO2(value) { this.dto.language_ISO2 = value; }
  /**
  */
  get caption() { return this.dto.caption; }
  set caption(value) { this.dto.caption = value; }
  /**
  */
  get isDefault() { return this.dto.isDefault; }
  set isDefault(value) { this.dto.isDefault = value; }
  /**
  * @type {int32}
  */
  get sort() { return this.dto.sort; }
  set sort(value) { this.dto.sort = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.parentcategoryid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.parentCategoryId = value;
    this.dto.language_ISO2 = qs.language_iso2;
    this.dto.caption = qs.caption;
    value = qs.isDefault === 'true' ? true : qs.isdefault;
    value = qs.isDefault === 'false' ? false : undefined;
    this.dto.isDefault = value;
    value = Number.parseFloat(qs.sort);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.sort = value;
  }
}
